module.exports = __webpack_public_path__ + "img/login_left2.965b03eb.jpg";